import {type AttendanceSceduleFragment} from 'web-app/react/invoicing-profiles/attendance-schedules/__generated__/queries.api-types';
import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ATTENDANCE_SCHEDULE';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (
        show: boolean,
        attendanceScheduleId: string,
        institutionId: string,
        useAsTemplate: boolean,
        refetchQueries: any[],
        successAction: (att: AttendanceSceduleFragment) => void,
        onHide?: () => void,
    ) => ({show, attendanceScheduleId, institutionId, useAsTemplate, refetchQueries, successAction, onHide}),
);
